import { IconHandbagSimple } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { useFormStateContext } from '../../../../providers'
import { useConditions } from '../useConditions'
import { messages } from './messages'
import { HistoricalPurchaseValueView } from './View'

interface Props {
  name: string
}

/**
 * @deprecated
 * This condition is being deprecated, so it starts hidden and cannot be added or edited.
 */
export function HistoricalPurchaseValue(props: Props) {
  const { name } = props
  const { formatMessage: i18n } = useIntl()

  const { form } = useFormStateContext()

  const value: number | undefined = useWatch({
    form,
    name,
  })

  useConditions({
    name,
    onEdit: () => {},
    label: i18n(messages.title),
    icon: <IconHandbagSimple />,
    hidden: true,
  })

  const handleRemove = () => form.setValue(name, undefined)

  return <HistoricalPurchaseValueView value={value} onRemove={handleRemove} />
}
